module.exports = __webpack_public_path__ + "static/media/money.d797c7b0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/money.jpeg
// module id = 638
// module chunks = 0